import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITimeInput from 'UIComponents/input/UITimeInput';
import I18n from 'I18n';
import { ONCE, ScheduleWindowTranslationKeys } from 'automation-ui-enrollment/constants/scheduledEnrollment/ScheduleCadence';
import UISelect from 'UIComponents/input/UISelect';
import Small from 'UIComponents/elements/Small';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TimeOfDaySelect = ({
  controlUse,
  readOnly,
  schedule,
  onTimeChange,
  onScheduleWindowChange,
  showTimeZone
}) => {
  var _ScheduleWindowTransl, _ScheduleWindowTransl2, _ScheduleWindowTransl3, _ScheduleWindowTransl4, _ScheduleWindowTransl5, _ScheduleWindowTransl6, _ScheduleWindowTransl7, _ScheduleWindowTransl8;
  const scheduleWindowHelpText = (_ScheduleWindowTransl = ScheduleWindowTranslationKeys[schedule.getScheduleWindow()]) === null || _ScheduleWindowTransl === void 0 || (_ScheduleWindowTransl2 = _ScheduleWindowTransl.getHelpText) === null || _ScheduleWindowTransl2 === void 0 ? void 0 : _ScheduleWindowTransl2.call(_ScheduleWindowTransl);
  return /*#__PURE__*/_jsx(UIFormControl, {
    required: true,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.timeOfDay.tooltip"
    }),
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.timeOfDay.label"
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [schedule.getCadence() !== ONCE && /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "300",
        as: "div",
        children: [/*#__PURE__*/_jsx(UISelect, {
          "aria-label": I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.timeOfDay.label'),
          menuStyle: {
            minHeight: 274
          } /* Show 4 options without scrolling */,
          value: schedule.getScheduleWindow(),
          onChange: onScheduleWindowChange,
          options: [{
            text: I18n.text(ScheduleWindowTranslationKeys['BEFORE_BUSINESS_HOURS'].titleKey),
            value: 'BEFORE_BUSINESS_HOURS',
            help: (_ScheduleWindowTransl3 = ScheduleWindowTranslationKeys['BEFORE_BUSINESS_HOURS']) === null || _ScheduleWindowTransl3 === void 0 || (_ScheduleWindowTransl4 = _ScheduleWindowTransl3.getHelpText) === null || _ScheduleWindowTransl4 === void 0 ? void 0 : _ScheduleWindowTransl4.call(_ScheduleWindowTransl3)
          }, {
            text: I18n.text(ScheduleWindowTranslationKeys['DURING_BUSINESS_HOURS'].titleKey),
            value: 'DURING_BUSINESS_HOURS',
            help: (_ScheduleWindowTransl5 = ScheduleWindowTranslationKeys['DURING_BUSINESS_HOURS']) === null || _ScheduleWindowTransl5 === void 0 || (_ScheduleWindowTransl6 = _ScheduleWindowTransl5.getHelpText) === null || _ScheduleWindowTransl6 === void 0 ? void 0 : _ScheduleWindowTransl6.call(_ScheduleWindowTransl5)
          }, {
            text: I18n.text(ScheduleWindowTranslationKeys['AFTER_BUSINESS_HOURS'].titleKey),
            value: 'AFTER_BUSINESS_HOURS',
            help: (_ScheduleWindowTransl7 = ScheduleWindowTranslationKeys['AFTER_BUSINESS_HOURS']) === null || _ScheduleWindowTransl7 === void 0 || (_ScheduleWindowTransl8 = _ScheduleWindowTransl7.getHelpText) === null || _ScheduleWindowTransl8 === void 0 ? void 0 : _ScheduleWindowTransl8.call(_ScheduleWindowTransl7)
          }, {
            text: I18n.text(ScheduleWindowTranslationKeys['SPECIFIC_TIME'].titleKey),
            value: 'SPECIFIC_TIME',
            help: I18n.text('automation-ui-enrollment.redesign.scheduledTriggers.tabs.enrollment.scheduleInput.scheduleWindow.specificTimeHelp')
          }],
          readOnly: readOnly
        }), scheduleWindowHelpText && /*#__PURE__*/_jsx(Small, {
          children: scheduleWindowHelpText
        })]
      }), schedule.getScheduleWindow() === 'SPECIFIC_TIME' && /*#__PURE__*/_jsx(UITimeInput, {
        "aria-label": "Time of day",
        "data-test-id": "select-schedule-time-of-day"
        /* interpolating time zone string into the datetime format. This will result in appending portal time zone onto the 'LT' datetime format */,
        format: showTimeZone ? `LT [${I18n.moment.portalTz().format('z')}]` : `LT`,
        onChange: onTimeChange,
        readOnly: readOnly,
        value: schedule.getTimeInMinutes(),
        use: controlUse
      })]
    })
  });
};
export default TimeOfDaySelect;